import axios, { AxiosError } from "axios";
import { useMutation } from "react-query";
import CreateAnnouncementApiRequest from "../request/CreateAnnouncementApiRequest";

const CreateAnnouncementApiService = async (request: CreateAnnouncementApiRequest): Promise<boolean> => {
  const url = "/announcements/";
  const { data } = await axios.post(url, request);
  return data;
};

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const useCreateAnnouncementApiService = () =>
  useMutation<boolean, AxiosError, CreateAnnouncementApiRequest>(
    CreateAnnouncementApiService, {
      mutationKey: "CreateAnnouncementApiService"
    }
  );
export default useCreateAnnouncementApiService;